import React from 'react';

import BreederProfileLocationAndParentDogsContainer from 'dpl/containers/BreederProfile/Show/BreederProfileLocationAndParentDogsContainer';
import BreederProfilePhotosCarouselSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfilePhotosCarouselSectionContainer';
import BreederProfilePricingSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfilePhotosCarouselSectionContainer/BreederProfilePricingSectionContainer';
import BreederProfileReviewsSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileReviewsSectionContainer';

import BreederProfileIntroSection from '../BreederProfileIntroSection';

export default function BreederProfileAboutTab() {
  return (
    <div className="BreederProfileAboutTab">
      <BreederProfileIntroSection />
      <BreederProfilePhotosCarouselSectionContainer />
      <BreederProfilePricingSectionContainer />
      <BreederProfileLocationAndParentDogsContainer />
      <BreederProfileReviewsSectionContainer />
    </div>
  );
}
